
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
//import { ConnectedRouter } from 'react-router-redux'
import { createBrowserHistory } from 'history'
import Layout from './components/Layout'
import Embeds from './components/Embeds'
import configure from './store/configure'
//import registerServiceWorker from './registerServiceWorker'
import './App.scss'

// Create browser history to use in the Redux store
const basename = document.getElementsByTagName('base')[0].getAttribute('href')
const history = createBrowserHistory({ basename })

const store = configure(history)

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)
root.render(
    <Provider store={store}>
        {/*<ConnectedRouter history={history}>*/}
            { window.location.href.indexOf('/embed/') >= 0 ? 
                <Embeds /> :
                <Layout /> }         
        {/*</ConnectedRouter>*/}
    </Provider>)

/* TODO: we're removing the service worker for now to account for 
    the removal of the backend, this is done in public/index/html. 
    should add it back in in the near futur while really understanding 
    what we're trying to cache - rrogers */
//registerServiceWorker()
